/**
 * DevExtreme (esm/ui/text_box/text_box.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import TextBox from "../../__internal/ui/text_box/m_text_box";
export default TextBox;